import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InsertMidSpotMutationVariables = Types.Exact<{
  input: Types.InsertMidSpotInput;
}>;


export type InsertMidSpotMutation = { __typename?: 'MutationRoot', insertMidSpot: { __typename?: 'InsertSpotFailure', message: string } | { __typename?: 'InsertSpotSuccess', spot: { __typename?: 'Spot', id: string } } };

export type RemoveMultipleSpotsMutationVariables = Types.Exact<{
  input: Types.RemoveMultipleSpotsInput;
}>;


export type RemoveMultipleSpotsMutation = { __typename?: 'MutationRoot', removeMultipleSpots: Array<{ __typename?: 'Spot', id: string }> };


export const InsertMidSpotDocument = gql`
    mutation InsertMidSpot($input: InsertMidSpotInput!) {
  insertMidSpot(input: $input) {
    ... on InsertSpotSuccess {
      spot {
        id
      }
    }
    ... on InsertSpotFailure {
      message
    }
  }
}
    `;

export function useInsertMidSpotMutation() {
  return Urql.useMutation<InsertMidSpotMutation, InsertMidSpotMutationVariables>(InsertMidSpotDocument);
};
export const RemoveMultipleSpotsDocument = gql`
    mutation RemoveMultipleSpots($input: RemoveMultipleSpotsInput!) {
  removeMultipleSpots(input: $input) {
    id
  }
}
    `;

export function useRemoveMultipleSpotsMutation() {
  return Urql.useMutation<RemoveMultipleSpotsMutation, RemoveMultipleSpotsMutationVariables>(RemoveMultipleSpotsDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertMidSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ insertMidSpot })
 *   )
 * })
 */
export const mockInsertMidSpotMutation = (resolver: ResponseResolver<GraphQLRequest<InsertMidSpotMutationVariables>, GraphQLContext<InsertMidSpotMutation>, any>) =>
  graphql.mutation<InsertMidSpotMutation, InsertMidSpotMutationVariables>(
    'InsertMidSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveMultipleSpotsMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeMultipleSpots })
 *   )
 * })
 */
export const mockRemoveMultipleSpotsMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveMultipleSpotsMutationVariables>, GraphQLContext<RemoveMultipleSpotsMutation>, any>) =>
  graphql.mutation<RemoveMultipleSpotsMutation, RemoveMultipleSpotsMutationVariables>(
    'RemoveMultipleSpots',
    resolver
  )
